import React, { Fragment, useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Button } from "reactstrap";
import { useNavigate } from "react-router";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import axios from "axios";
import exerciseImage from "../../../../src/assets/ovah/17.SquatPulse.png";

const AllExercisesTable = ({ exercises, setExerciseIndex, exerciseIndex }) => {
  const [modal, setModal] = useState(false);
  const [selectedExercise, setSelectedExercise] = useState(null);

  const toggleModal = () => {
    setModal(!modal);
  };

  const handleDelete = (exercise) => {
    setSelectedExercise(exercise);
    toggleModal();
  };

  const confirmDelete = () => {
    console.log("Deleting exercise:", selectedExercise);
    // Add the logic to delete the exercise from the server/database here
    toggleModal();
  };

  const history = useNavigate();

  const handleViewDetails = (exercise) => {
    history(`/exercises/${exercise.id}`);
  };

  
  const handleEdit = (exercise) => {
      history(`/excercise/edit/${exercise._id}`);
  };


  const handleViewInquiry = (exercise) => {
    history("/inquiry");
  };

  const customColumns = [
    {
      name: "Title",
      selector: (row) => row.title || row.workOutName,
      sortable: true,
      center: false,
    },
    {
      name: "Image",
      cell: (row) => (
        <img
          src={row.exercisePicUrl}
          alt={row.title || row.workOutName}
          style={{ width: "100px", height: "110px" }}
        />
      ),
      sortable: false,
      center: true,
    },
    {
      name: "Category",
      selector: (row) => row.category || row.workOutType,
      sortable: true,
      center: false,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <Button
            color=""
            onClick={() => handleEdit(row)}
            style={{ padding: "0.25rem", marginRight: "0.5rem" }}
          >
            <i className="icon-pencil"></i>
          </Button>
          {/* <Button
            color=""
            onClick={() => handleDelete(row)}
            style={{ padding: "0.25rem", marginRight: "0.5rem" }}
          >
            <i className="icon-trash"></i>
          </Button> */}
          {/* <Button
            color=""
            onClick={() => handleViewDetails(row)}
            style={{ padding: "0.25rem" }}
          >
            <i className="icon-more-alt"></i>
          </Button> */}
        </div>
      ),
      button: true,
      width: "20%",
      center: true,
    },
  ];

  return (
    <Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <h3>View Exercises</h3>
          </div>
        </div>
      </div>
      <div className="table-responsive support-table mt-2">
        <DataTable
          columns={customColumns}
          data={exercises}
          striped={true}
          center={true}
          pagination
          className="p-2"
        />
      </div>
      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Confirm Delete</ModalHeader>
        <ModalBody>
          Are you sure you want to delete the exercise titled "
          {selectedExercise?.title || selectedExercise?.workOutName}"?
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={confirmDelete}>
            Delete
          </Button>{" "}
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default AllExercisesTable;

// import React, { Fragment, useState } from "react";
// import DataTable from "react-data-table-component";
// import { Button } from "reactstrap";
// import { useNavigate } from "react-router";
// import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
// import exerciseImage from "../../../../src/assets/ovah/17.SquatPulse.png";

// const AllExercisesTable = () => {
//   const [modal, setModal] = useState(false);
//   const [selectedExercise, setSelectedExercise] = useState(null);

//   const toggleModal = () => {
//     setModal(!modal);
//   };

//   const handleDelete = (exercise) => {
//     setSelectedExercise(exercise);
//     toggleModal();
//   };

//   const confirmDelete = () => {
//     console.log("Deleting exercise:", selectedExercise);
//     toggleModal();
//   };

//   const [exercisesData] = useState([
//     {
//       id: 1,
//       title: "Push Ups",
//       image: "pushups.jpg",
//       inquiry: <i className="fa fa-info-circle"></i>,
//       category: "Daily Workout",
//     },
//     {
//       id: 2,
//       title: "Squats",
//       image: "squats.jpg",
//       inquiry: <i className="fa fa-info-circle"></i>,
//       category: "Single Exercise",
//     },
//   ]);

//   const history = useNavigate();

//   const handleViewDetails = (exercise) => {
//     history(`/exercises/${exercise.id}`);
//   };

//   const handleEdit = (exercise) => {
//     history(`/exercises/edit/${exercise.id}`);
//   };

//   const handleViewInquiry = (exercise) => {
//     history("/inquiry");
//   };

//   const customColumns = [
//     {
//       name: "Title",
//       selector: (row) => row.title,
//       sortable: true,
//       center: false,
//     },
//     {
//       name: "Image",
//       cell: (row) => (
//         <img
//           src={exerciseImage}
//           alt={row.title}
//           style={{ width: "50px", height: "90px" }}
//         />
//       ),
//       sortable: false,
//       center: true,
//     },

//     {
//       name: "Category",
//       selector: (row) => row.category,
//       sortable: true,
//       center: false,
//     },

//     {
//       name: "Actions",
//       cell: (row) => (
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "flex-start",
//           }}
//         >
//           <Button
//             color=""
//             onClick={() => handleEdit(row)}
//             style={{ padding: "0.25rem", marginRight: "0.5rem" }}
//           >
//             <i className="icon-pencil"></i>
//           </Button>
//           <Button
//             color=""
//             onClick={() => handleDelete(row)}
//             style={{ padding: "0.25rem", marginRight: "0.5rem" }}
//           >
//             <i className="icon-trash"></i>
//           </Button>
//           <Button
//             color=""
//             onClick={() => handleViewDetails(row)}
//             style={{ padding: "0.25rem" }}
//           >
//             <i className="icon-more-alt"></i>
//           </Button>
//         </div>
//       ),
//       button: true,
//       width: "20%",
//       center: true,
//     },
//   ];

//   return (
//     <Fragment>
//       <div className="container-fluid">
//         <div className="row">
//           <div className="col-md-12">
//             <h3>View Exercises</h3>
//           </div>
//         </div>
//       </div>
//       <div className="table-responsive support-table mt-2">
//         <DataTable
//           columns={customColumns}
//           data={exercisesData}
//           striped={true}
//           center={true}
//           pagination
//           className="p-2"
//         />
//       </div>
//       <Modal isOpen={modal} toggle={toggleModal}>
//         <ModalHeader toggle={toggleModal}>Confirm Delete</ModalHeader>
//         <ModalBody>
//           Are you sure you want to delete the exercise titled "
//           {selectedExercise?.title}"?
//         </ModalBody>
//         <ModalFooter>
//           <Button color="danger" onClick={confirmDelete}>
//             Delete
//           </Button>{" "}
//           <Button color="secondary" onClick={toggleModal}>
//             Cancel
//           </Button>
//         </ModalFooter>
//       </Modal>
//     </Fragment>
//   );
// };

// export default AllExercisesTable;
